import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import HeroSection from './components/HeroSection';
import MessageSection from './components/MessageSection';
import SuccessPickupSection from './components/SuccessPickupSection';
import ReasonsSection from './components/ReasonsSection';
import CTASection from './components/CTASection';
import HomeFaqSection from './components/HomeFaqSection';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

export const faqItems = [
  {
    question: '東京シニア婚活相談所「縁結び和はは」に入会するにはどうすればいいですか？',
    answer: 'まずは無料相談をお申し込みください。お電話（03-4500-8399）・LINE・ウェブフォームからご連絡いただけます。カウンセラーが丁寧にサポートします。',
  },
  {
    question: '50代・60代・70代でも婚活できますか？',
    answer: 'はい、可能です。縁結び和ははは、東京シニア婚活に特化した相談所として、50代・60代・70代の方の婚活・再婚を多数サポートしてきました。年齢を重ねてからの幸せな再出発を年齢に関係なくご支援します。',
  },
  {
    question: '東京だけでなく関東在住でも利用できますか？',
    answer: 'はい、東京・関東全域の方にご利用いただけます。オンライン面談にも対応しておりますので、お気軽にお問い合わせください。',
  },
  {
    question: 'シニア婚活相談所と婚活アプリの違いは何ですか？',
    answer: '婚活アプリは自分でプロフィールを作りメッセージを送る方式ですが、婚活相談所はカウンセラーが寄り添ってサポートします。東京のシニア婚活は対面のアドバイスやプロフィール作成のサポートなど、プロのカウンセラーによる丁寧な指導が大きな強みです。',
  },
  {
    question: '無料相談はどのような内容ですか？',
    answer: '入会前の希望条件や活動ペース、料金などについて具体的にお話しします。約60分から対応しています。強制や入会則しはございませんのでお気軽にどうぞ。',
  },
];

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${SITE_URL}/#organization`,
    name: '縁結び 和はは',
    alternateName: '東京シニア婚活相談所 縁結び和はは',
    url: SITE_URL,
    telephone: '03-4500-8399',
    description: '東京のシニア婚活相談所。50代・60代・70代の婚活・再婚をサポート。東京在住のシニアの方に寄り添った丁寧なカウンセリングを提供。',
    address: {
      '@type': 'PostalAddress',
      addressRegion: '東京都',
      addressLocality: '東京',
      addressCountry: 'JP',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 35.6894875,
      longitude: 139.6917064,
    },
    areaServed: [
      { '@type': 'City', name: '東京都' },
      { '@type': 'City', name: '神奈川県' },
      { '@type': 'City', name: '埼玉県' },
      { '@type': 'City', name: '千葉県' },
    ],
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '10:00',
        closes: '18:00',
      },
    ],
    priceRange: '¥¥',
    knowsAbout: ['シニア婚活', '東京婚活相談所', '50代婚活', '60代婚活', '70代婚活', '熟年再婚'],
    sameAs: [],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: SITE_URL,
    name: '縁結び 和はは',
    description: '東京シニア婚活相談所 | 50代・60代・70代の婚活・再婚をサポート',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/blog?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  },
];

export default function Home() {
  return (
    <>
      <SeoHead
        title="東京シニア婚活 縁結び和はは | 50代・60代・70代の婚活相談所"
        description="東京のシニア婚活相談所「縁結び和はは」。50代・60代・70代の婚活・再婚をサポート。東京在住のシニアに特化した丁寧なカウンセリングと本格マッチングで幸せなパートナー探しを。無料相談受付中。"
        keywords="シニア婚活, 東京, 婚活相談所, 50代婚活, 60代婚活, 70代婚活, シニア再婚, 熟年婚活"
        path="/"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <MessageSection />
        <SuccessPickupSection />
        <ReasonsSection />
        <HomeFaqSection faqItems={faqItems} />
        <CTASection />
      </main>
      <Footer />
      <LineFloatingButton />
    </>
  );
}